/**
 * Best-effort: paint ConcealCamo into Judge.me default/initial avatars only.
 * Keeps reviewer-uploaded photos. Same-origin .jdgm-* DOM (not iframe).
 */
(function () {
  const ICON_SEL = '.jdgm-rev__icon, .jdgm-full-rev__icon';
  const REV_SEL = '.jdgm-rev, .jdgm-full-rev';

  function createCamoDataUrl(seed, size) {
    if (window.ConcealCamo && typeof window.ConcealCamo.createCamoDataUrl === 'function') {
      return window.ConcealCamo.createCamoDataUrl(seed, size);
    }
    return null;
  }

  function hasCustomPhoto(icon) {
    if (
      icon.classList.contains('jdgm-rev__icon--with-pic') ||
      icon.classList.contains('jdgm-full-rev__icon--with-pic')
    ) {
      return true;
    }

    const img = icon.querySelector('img.jdgm-rev__pic-img, img.jdgm-full-rev__pic-img, img');
    if (img) {
      const src = (img.currentSrc || img.getAttribute('src') || '').trim();
      if (src && !/^(data:image\/gif|about:blank|#)/i.test(src) && !/placeholder|1x1|blank\.|transparent/i.test(src)) {
        return true;
      }
    }

    // Photo-as-background (not our camo)
    const inlineBg = icon.style.backgroundImage || '';
    if (/url\s*\(\s*['"]?https?:/i.test(inlineBg) && icon.dataset.camoApplied !== 'true') {
      return true;
    }

    return false;
  }

  function seedForReview(rev) {
    const reviewId =
      rev.getAttribute('data-review-id') ||
      rev.getAttribute('data-reviewid') ||
      (rev.id && /^jdgm/i.test(rev.id) ? rev.id : null);
    if (reviewId) return String(reviewId);

    const authorEl = rev.querySelector('.jdgm-rev__author, .jdgm-full-rev__author');
    const author = (authorEl && authorEl.textContent ? authorEl.textContent : '').trim();

    const host = document.querySelector('[data-conceal-judgeme-camo]');
    const customerId = host && host.getAttribute('data-customer-id');
    const customerName = ((host && host.getAttribute('data-customer-name')) || '').trim().toLowerCase();
    if (customerId && author && customerName && author.toLowerCase() === customerName) {
      return String(customerId);
    }

    return 'jdgm-name:' + (author || 'anonymous');
  }

  function paintIcon(icon) {
    if (!icon || icon.dataset.camoApplied === 'true' || icon.dataset.camoSkip === 'true') return;

    if (hasCustomPhoto(icon)) {
      icon.dataset.camoSkip = 'true';
      return;
    }

    const rev = icon.closest(REV_SEL);
    if (!rev) return;

    const rect = icon.getBoundingClientRect();
    const size = Math.max(48, Math.round(rect.width) || 48);
    const url = createCamoDataUrl(seedForReview(rev), size * 2);
    if (!url) return;

    icon.classList.add('conceal-camo-avatar', 'conceal-camo-avatar--judgeme');
    icon.style.setProperty('background-image', `url(${url})`, 'important');
    icon.style.setProperty('background-size', 'cover', 'important');
    icon.style.setProperty('background-position', 'center', 'important');
    icon.style.setProperty('background-color', 'transparent', 'important');
    icon.style.setProperty('color', 'transparent', 'important');
    icon.dataset.camoApplied = 'true';
  }

  function enhance(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (root && root.nodeType === 1 && root.matches && root.matches(ICON_SEL)) {
      paintIcon(root);
    }
    scope.querySelectorAll(ICON_SEL).forEach(paintIcon);
  }

  function boot() {
    enhance(document);

    if (!window.__concealJudgemeCamoObs) {
      const obs = new MutationObserver((mutations) => {
        for (let i = 0; i < mutations.length; i += 1) {
          const m = mutations[i];
          if (m.type !== 'childList') continue;
          m.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            enhance(node);
          });
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      window.__concealJudgemeCamoObs = obs;
    }

    // Judge.me may finish setup after our first pass
    let tries = 0;
    const retry = window.setInterval(() => {
      tries += 1;
      enhance(document);
      if (tries >= 8) window.clearInterval(retry);
    }, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => enhance(document));
})();
